import * as e from "react";
import { FormField as r } from "./FormField.js";
import { useAuthenticator as t } from "@aws-amplify/ui-react-core";
function m() {
  var _t = t(function (_ref) {
      var e = _ref.route;
      return [e];
    }),
    m = _t.fields,
    o = e.useRef(m.map(function (t, m) {
      return e.createElement(r, Object.assign({
        key: m
      }, t));
    })).current;
  return e.createElement(e.Fragment, null, o);
}
export { m as FormFields };